import { toCamelCase } from 'case-converter';
import { RateSchema } from './schemas';
import { AvailableRate, Rate, StaticRate } from './types';

type MapToRates = (staticRates: StaticRate[], availableRates: AvailableRate[]) => Rate[];

export const toRatesByAvailability: MapToRates = (staticRates, availableRates) => {
  const rates = staticRates
    .map((rate) => {
      const availableRate = availableRates.find(({ id }) => id === rate.rateCode);
      return RateSchema.parse({
        id: availableRate?.id ?? rate.rateCode,
        price: toCamelCase(availableRate?.from_price),
        title: rate.name ?? '',
        description: rate.description ?? '',
        imageUrl: rate.images?.[0] ?? '',
        cancellationPolicyText: rate.cancellationPolicyText,
        unAvailable: !availableRate || !availableRate?.from_price,
        uuid: rate._id,
      });
    })
    // @ISSUE: casting and extra sort loop could be avoided by reducing to 'groups' rather than mapping..
    // @TODO: Break out and resturcture List/ListItem so can control upstream mapping
    .sort((a, b) => Number(a.unAvailable) - Number(b.unAvailable));

  return rates;
};
